
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVerticalChargingLow as ObiBatteryVerticalChargingLowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-charging-low.js';
 
 
 

 
 export const ObiBatteryVerticalChargingLow = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-charging-low',
   elementClass: ObiBatteryVerticalChargingLowElement,
   events: {
     
   }
  });
 
 